import { render, staticRenderFns } from "./UIFileInput.vue?vue&type=template&id=7cd1b027&"
import script from "./UIFileInput.vue?vue&type=script&lang=js&"
export * from "./UIFileInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports